module.exports = __webpack_public_path__ + "media/images/landing/crime/commercial-c1a899a7f70238d0a4fd1c8e3f3e368c.png";